"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var React = __importStar(require("react"));

var EnterFullscreenIcon = function EnterFullscreenIcon(_a) {
  return React.createElement("svg", {
    viewBox: "0 0 16 16"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M14.5,7.511l-0.002-4.87C14.341,1.5,13.346,1.5,12.867,1.5H8.511v1.002h4.282L9.16,6.153l0.71,0.706l3.631-3.649 l-0.003,4.301H14.5z"
  }), React.createElement("path", {
    d: "M3.211,13.502l3.637-3.62l-0.706-0.71l-3.634,3.617V8.512H1.506l0.001,4.317C1.441,13.82,1.825,14.381,2.716,14.5 l4.775-0.003L7.49,13.495L3.211,13.502z"
  })));
};

exports["default"] = EnterFullscreenIcon;